import { Component, OnInit } from '@angular/core';
import { OrderControllerService } from '../../../../services';
import { Title } from '@angular/platform-browser';
import { UpcomingOrdersComponent } from '../upcoming-orders/upcoming-orders.component';
import { CvdDongleInfoComponent } from '../cvd-dongle-info/cvd-dongle-info.component';
import { ErrorsByShipDateComponent } from '../errors-by-ship-date/errors-by-ship-date.component';
import { ErrorsByComponentComponent } from '../errors-by-component/errors-by-component.component';
import { ComponentStatusComponent } from '../component-status/component-status.component';
import { UpcomingOrdersWithMissingContentComponent } from '../upcoming-orders-with-missing-content/upcoming-orders-with-missing-content.component';
import { OrdersByStatusComponent } from '../orders-by-status/orders-by-status.component';

@Component({
  selector: 'insight-operational-dashboard',
  templateUrl: './operational-dashboard.component.html',
  styleUrls: ['./operational-dashboard.component.scss', '../../scss/operational-dashboard-shared.scss'],
  imports: [UpcomingOrdersComponent, CvdDongleInfoComponent, ErrorsByShipDateComponent, ErrorsByComponentComponent, ComponentStatusComponent, UpcomingOrdersWithMissingContentComponent, OrdersByStatusComponent]
})
export class OperationalDashboardComponent implements OnInit {
  constructor(private orderControllerService: OrderControllerService, private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle("Insight - Operational Dashboard");
    // Take over the refresh timer from the main page
    this.orderControllerService.updateRefreshTimer(5000, false);
    // Trigger the refresh event
    this.orderControllerService.triggerTimerRefreshedEvent();
  }
}
